import Header from './components/Header';
import Footer from './components/Footer';
import { BgGrad } from './DefaultLayout.styles';
import { Container, Grid } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const DefaultLayout = ({
  subscriptionStatus,
  subscribeToNotifications,
}: {
  subscriptionStatus: string;
  subscribeToNotifications: (email: { EmailId: string }) => void;
}) => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, [location.pathname]);
  return (
    <>
      <Header />
      <BgGrad>
        <Container maxWidth={false} sx={{ px: '0 !important' }}>
          <Grid container justifyContent="center">
            <Outlet />
          </Grid>
        </Container>
      </BgGrad>
      
      <Footer subscriptionStatus={subscriptionStatus} subscribeToNotifications={subscribeToNotifications} />
    </>
  );
};

export default DefaultLayout;
